import types from './types';

const INITIAL_STATE = {
  isChecking: false,
  isValidatingOPTOPH: false,

  result: [],
  validationResult: {} as any,
};

const authSpecialistsReducer = (state = INITIAL_STATE, action: any) => {
  switch (action.type) {

    case types.CHECK_SPECIALIST_AUTH_HISTORY_REQUEST:
      return {
        ...state,
        result: [],
        isChecking: true,
      };

    case types.CHECK_SPECIALIST_AUTH_HISTORY_SUCCESS:
      return {
        ...state,
        result: action.payload,
        isChecking: false,
      };

    case types.CHECK_SPECIALIST_AUTH_HISTORY_FAILURE:
      return {
        ...state,
        result: [],
        isChecking: false,
      };

    case types.VALIDATE_OPT_OPH_REQUEST:
      return {
        ...state,
        isValidatingOPTOPH: true,
      };

    case types.VALIDATE_OPT_OPH_SUCCESS:
      return {
        ...state,
        validationResult: action.payload,
        isValidatingOPTOPH: false,
      };

    case types.VALIDATE_OPT_OPH_FAILURE:
      return {
        ...state,
        validationResult: {} as any,
        isValidatingOPTOPH: false,
      };

    default:
      return state;
  }
};

export default authSpecialistsReducer;
